import user from '@motionelements/core/src/store/modules/user.js';

export default {
  namespaced: true,
  state: () => user.state,
  getters: user.getters,
  actions: user.actions,
  mutations: user.mutations,
};
